import Dashboard from "../components/application/Dashboard/Dashboard";


const AppRoutes = [
  {
    key: "0",
    path: "/dashboard",
    exact: true,
    name: "dashboard",
    component: <Dashboard />,
  },
  
];
export default AppRoutes;
